export default __webpack_public_path__ + "static/media/TicTac-Learn-Website_element-22-2.72edf93e.png";